import React from 'react';
import Section from 'components/UI/Section';
import * as Icon from '@material-ui/icons';
import SidebarMenu from 'components/layout/Partials/SidebarMenu';
import { Grid, IconButton, Slide } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { themeSelector } from 'redux/theme/selectors';
import { defaultStyles } from 'utils/Theme';
import { setSideBarVisibility } from 'redux/actions/themeActions';

const SidebarMenuContainer = () => {
    const { sidebarVisibility } = useSelector(themeSelector);
    const dispatch = useDispatch();
    const classes = defaultStyles();

    const closeSidePanel = () => {
        dispatch(setSideBarVisibility(false));
    };

    const largeWindow = window.innerWidth > 1000;

    return (
        <Slide direction="right" in={sidebarVisibility} appear={false}>
            <div className="o-page__sidebar js-page-sidebar">
                <aside className="c-sidebar">
                    <Section elevation={largeWindow ? 0 : 3}>
                        <div className="o-line" style={{ padding: 10 }}>
                            <Grid
                                container
                                direction={'row'}
                                justifyContent="space-between"
                            >
                                {!largeWindow && (
                                    <Grid item xs={2}>
                                        <IconButton onClick={closeSidePanel}>
                                            <Icon.MenuOpen
                                                size={12}
                                                className={classes.colorPrimary}
                                            />
                                        </IconButton>
                                    </Grid>
                                )}
                            </Grid>
                        </div>
                        <div className="c-sidebar__body">
                            <SidebarMenu />
                        </div>
                    </Section>
                </aside>
            </div>
        </Slide>
    );
};

export default SidebarMenuContainer;
